<template>
    <SectionBasicLayout
        title='settings.browser_notifications.title'
        content_class="browser-notifications"
        close_route="settings"
    >
        <template #content>
            <BrowserNotifications></BrowserNotifications>
        </template>
    </SectionBasicLayout>

</template>

<script setup>
    import BrowserNotifications from './Partials/BrowserNotifications.vue'
    import SectionBasicLayout   from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
</script>
